/* Layout */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { ServiceUnavailableError, useAuthService } from '@core/auth.service';
import { initApp } from '@stores/actions/system.action';
import { toast } from '@stores/actions/toast.action';
import { setUser } from '@stores/actions/user.action';
import { RootState } from '@stores/models/store';
import 'assets/styles/app.scss';

import { LaunchDarklyProvider } from '@/web/src/context/LaunchDarkly.context';

import { Main } from './layouts/Main';
import { Unavailable } from './pages/Error/Unavailable';

export const App = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { initializeToken, getMe } = useAuthService();
  const user = useSelector((state: RootState) => state.user);
  const [isUnavailable, setIsUnavailable] = useState(false);

  useEffect(() => {
    initializeToken();
  }, []);

  useEffect(() => {
    const getUser = async () => {
      try {
        const user = await getMe();
        dispatch(setUser(user));

        if (user.emulateBy !== '') {
          dispatch(
            toast({
              message: t('profile_menu.impersonate.message', {
                profileName: user.fullname,
              }),
              level: 'success',
            }),
          );
        }
      } catch (error) {
        setIsUnavailable(error instanceof ServiceUnavailableError);

        if (!(error instanceof ServiceUnavailableError)) {
          console.error(error);
        }
      }
    };
    getUser();
    dispatch(initApp());
  }, [dispatch]);

  if (isUnavailable) {
    return <Unavailable />;
  }

  if (!user.isAuthenticated) {
    return <div className="spinner" />;
  }

  return (
    <LaunchDarklyProvider user={user}>
      <Main />
    </LaunchDarklyProvider>
  );
};
